// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"617":"75902251","760":"69afd409"}[chunkId] + ".chunk.css";
};